module.exports = __webpack_public_path__ + "img/afc-bournemouth-logo-icon.e6de24ea.png";